/*
* @author  Agence Dn'D <contact@dnd.fr>
* @license https://opensource.org/licenses/osl-3.0.php  Open Software License (OSL 3.0)
* @link    https://www.dnd.fr/
*/

function updateTotalPrice() {
    const qtyInput = document.querySelector('input[name="quantity"]');
    if (!qtyInput) return;

    const qty = parseInt(qtyInput.value, 10) || 1;

    document.querySelectorAll('[data-total-price]').forEach((priceEl) => {
        const valueEl = priceEl.querySelector('[data-total-price-value]');
        if (!valueEl) return;

        const unitPrice = parseInt(priceEl.dataset.unitPrice, 10);
        const formattedUnitPrice = parseFloat(priceEl.dataset.unitPriceFormatted.replace(/\s/g, '').replace(',', '.'));
        const decimals = (priceEl.dataset.unitPriceFormatted.split(/[,.]/).pop() || '').length;

        const total = (unitPrice * qty) / 100 || 0;
        const formatted = total.toLocaleString(undefined, {
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
        });

        valueEl.textContent = formatted;
    });
}

document.addEventListener('change', (e) => {
    if (e.target.closest('input[name="quantity"]')) updateTotalPrice();
});

document.addEventListener('on:variant:change', () => {
    requestAnimationFrame(() => updateTotalPrice());
});